import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map, of, switchMap } from 'rxjs';
import Swal from 'sweetalert2';
import { Atencion, AtencionDashboard } from '../../pages/pacientes/pacientes';
import { AtencionService } from '../../core/services/atencion.service';
import { EstadoAtencionService } from '../../core/services/estado-anterior.service';
@Injectable({
  providedIn: 'root',
})
export class InicioAtencionService {
  private iniciando = false; // evita doble clic

  constructor(
    private router: Router,
    private atencionService: AtencionService,
  ) {}

  abrirConsulta(atencion: Atencion, alTerminar?: () => void): void {
    if (!atencion.id || this.iniciando) {
      return;
    }

    const id = atencion.id;
    this.iniciando = true;

    const iniciar$ =
      atencion.estado === 'EN_ATENCION'
        ? of(atencion) // ya está en curso, no hace falta otra llamada
        : this.atencionService.iniciarAtencion(id).pipe(map((res: any) => res.data));

    iniciar$.subscribe({
      next: (actualizada) => {
        this.iniciando = false;
        alTerminar?.();

        this.router.navigate(['/consultas'], {
          state: { paciente: actualizada.paciente, atencion: actualizada },
        });
      },
      error: (error) => {
        this.iniciando = false;
        console.error('Error al iniciar atención:', error);

        Swal.fire({
          icon: error?.status === 409 ? 'info' : 'error',
          title: 'No se pudo iniciar la consulta',
          text: error?.error?.message ?? 'Ocurrió un error al iniciar la atención.',
          confirmButtonColor: '#24575A',
        });
      },
    });
  }
}
